import { Component, OnInit, inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
 
@Component({
    selector: 'carm-customs-brokers-list',
    template: ''
})
export class CustomsBrokersListComponent implements OnInit  {
    protected translateService: TranslateService;

    constructor() {
        this.translateService = inject(TranslateService);
    }
 
    ngOnInit() {
        window.location.href = this.translateService.instant('application_features.homepage.sections.brokers.brokersLink');
    }
}